/* Rquiere de mixin.js */

var storeRackSideRow = {
	data () {
		return {
			listStoreRackSideRows: [],
			methodsStoreRackSideRow: {
				get: 'storeRackSideRows',
				show: 'storeRackSideRow/',
			},
			paginationStoreRackSideRows: [],
			searchStoreRackSideRows: '',
            searchingStoreRackSideRow: false,
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		getAllStoreRackSideRows(page = 1) {
			this.searchingStoreRackSideRow = true
			this.listStoreRackSideRows = []
			let parameters = '?search=' + this.searchStoreRackSideRows + '&page=' + page
			this.axiosActionIS(this.apiBackend + this.methodsStoreRackSideRow.get + parameters, 'GET', 'getAllStoreRackSideRowsResult')
        },
		getAllStoreRackSideRowsResult(response) {
			this.searchingStoreRackSideRow = false
			if(response.data.success == true) {
				this.listStoreRackSideRows = response.data.data
			}
            this.getAllStoreRackSideRowsResultLocal(response)
		},
        getAllStoreRackSideRowsResultLocal(response) {
            console.log('getAllStoreRackSideRowsResultLocal no desarrollado', response)
        },
		getStoreRackSideRow(id) {
			this.axiosActionIS(this.apiBackend + this.methodsStoreRackSideRow.show + id, 'GET', 'getStoreRackSideRowResult')
		},
        getStoreRackSideRowResult(response) {
            this.getStoreRackSideRowResultLocal(response)
        },
        getStoreRackSideRowResultLocal(response) {
            console.log('getStoreRackSideRowResultLocal no está desarrollado', response)
        },
	},
};

export default storeRackSideRow;